/* eslint-disable no-nested-ternary */
import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(({ tabs }: { tabs?: boolean }) => ({
  paddingTop: tabs ? 12 : 36,
}));

export const Title = styled("span")(() => ({
  color: "#465869",
  fontWeight: 700,
  fontSize: 16,
  fontFamily: "Manrope",
  lineHeight: "150%",
}));

export const ButtonSection = styled("div")(() => ({
  marginTop: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
}));

interface Options {
  active?: boolean;
  position?: boolean;
  disabled?: boolean;
}
export const Option = styled("div")(({ active, position, disabled }: Options) => ({
  border: disabled ? "none" : "1px solid #D0D5DD",
  borderRadius: position ? "8px 0 0 8px" : "0 8px 8px 0",
  backgroundColor: active ? "#E6EEF6" : disabled ? "#E4E7EC" : "transparent",
  color: active ? "#0055A4" : disabled ? "#98A2B3" : "#1D2939",
  cursor: disabled ? "default" : "pointer",
  width: 150,
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: 14,
  lineHeight: "20px",
  letterSpacing: "0.1px",
}));

export const GroupWrapper = styled("div")(() => ({
  marginTop: 28,
}));

export const Group = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const GroupLabel = styled("label")(() => ({
  color: "#308CDB",
  fontFamily: "Manrope",
  fontWeight: 600,
  fontSize: 14,
  lineHeight: "24px",
}));
